module.exports = __webpack_public_path__ + "static/eliza@large-4404cb07e9f64f6f550d2f8ccdc79f6a.jpg";